import React from "react";

import { IconChat } from "./icons";
import VideoPreview from "./VideoPreview";

/**
 * 最小化中のランチャー。
 * lead-dynamics の widget.js buildLauncher() / renderPresence() を移植したもの。
 *
 * 縦の並びは上から:
 *   × （閉じる＝小FABだけの状態にする）
 *   担当者アバター＋吹き出し（オンラインなら「今すぐ商談可能」）
 *   動画プレビュー（設定があるときだけ）
 *   「AIに相談する」CTA ＋ チャットバブル
 *
 * 畳んだ状態(minimized)では ×・担当者・CTA を隠して小さいバブルだけ残す。
 * ただしモバイルの丸トリガーはそのまま出す（畳んだ状態での唯一の入口になるため。
 * LD widget.js の renderVideoPreview に入っている [rev2 fix] と同じ扱い）。
 * バブルを押すと元のランチャーに戻る。
 *
 * モバイル(600px以下)は既定で畳んだ状態から始まる（LD の state.lmin と同じ）。
 */
const Launcher = (props) => {
  const {
    account,
    online,
    canBook,
    themeColor,
    minimized,
    // 動画
    videoUrl,
    videoMobile,
    videoVertical,
    onDismissVideo,
    onOpenVideo,
    // 操作
    onOpenChat,
    onStartMeeting,
    onOpenBooking,
    onMinimize,
    onRestore,
  } = props;

  const videoPreview = videoUrl ? (
    <VideoPreview
      url={videoUrl}
      mobile={videoMobile}
      vertical={videoVertical}
      onOpenFullscreen={onOpenVideo}
      onDismiss={onDismissVideo}
    />
  ) : null;

  // 畳んでいるときは小さいバブルだけ。
  // PCの自動再生カードは畳むと消えるが、モバイルの丸トリガーは残す。
  if (minimized) {
    return (
      <div className="aisdr-lc" style={{ "--aisdr-accent": themeColor }}>
        {videoMobile && videoPreview}
        <button
          type="button"
          className="aisdr-fab mini"
          onClick={onRestore}
          aria-label="チャットを開く"
        >
          <IconChat />
          <span className={`lc-dot ${online ? "on" : "off"}`} />
        </button>
      </div>
    );
  }

  // LD の renderPresence と同じ文言。ただし日程調整が未設定のときは
  // 「日程調整できます」と言えないので、チャットに誘導する文言にする。
  const speech = online
    ? "今すぐ商談可能な担当者がおります"
    : canBook
    ? "担当者と日程調整できます"
    : "ご質問にAIがお答えします";

  return (
    <div className="aisdr-lc" style={{ "--aisdr-accent": themeColor }}>
      <button
        type="button"
        className="lc-close"
        onClick={onMinimize}
        aria-label="閉じる"
      >
        ×
      </button>

      {/* LD と同じ出し分け。オンラインならその場で商談、
          オフラインなら日程調整（担当者のカレンダーの空き）へ誘導する。 */}
      <div
        className="lc-presence"
        onClick={online ? onStartMeeting : onOpenBooking}
      >
        <div className="lc-speech">{speech}</div>
        <div className="lc-avatars">
          <div className="lc-ava">
            <div className="lc-ava-c">
              {account?.avatar ? (
                <img src={account.avatar} alt="" />
              ) : (
                <span>{(account?.username || "?").slice(0, 1)}</span>
              )}
            </div>
            <span className={`lc-dot ${online ? "on" : "off"}`} />
          </div>
        </div>
      </div>

      {videoPreview}

      <div className="lc-row" onClick={onOpenChat}>
        <div className="bubble-cta">
          <b>AIに相談する</b>
          <span>すぐに答えが見つかります</span>
        </div>
        <button type="button" className="aisdr-fab" aria-label="チャットを開く">
          <IconChat />
          <span className={`lc-dot ${online ? "on" : "off"}`} />
        </button>
      </div>
    </div>
  );
};

export default Launcher;
